import { FormState, FormAction } from '../types/form';

export function formReducer(state: FormState, action: FormAction): FormState {
  switch (action.type) {
    case 'NEXT_STEP':
      return { 
        ...state, 
        currentStep: state.currentStep + 1,
        error: null // Limpa erros ao avançar
      };
    
    case 'PREV_STEP':
      return { 
        ...state, 
        currentStep: Math.max(0, state.currentStep - 1),
        error: null // Limpa erros ao voltar
      };
    
    case 'SET_LOADING':
      return { 
        ...state, 
        isLoading: action.payload,
        error: action.payload ? null : state.error // Limpa erros ao começar loading
      };
    
    case 'SET_ERROR':
      return { 
        ...state, 
        error: action.payload,
        isLoading: false // Garante que loading é desativado ao mostrar erro
      };
    
    case 'SET_COMPLETED':
      return { 
        ...state, 
        isCompleted: action.payload,
        isLoading: false,
        error: null // Limpa erros ao completar
      };
    
    case 'RESET':
      return {
        currentStep: 0,
        isLoading: false,
        error: null,
        isCompleted: false
      };
    
    default:
      return state;
  }
} 